import { toggleClass } from "../_vars";

export const accordionToggle = (accordion) => {
    const accordions = document.querySelectorAll(accordion);
    accordions.forEach((acc) => {
        const btn = acc.querySelector(".accordion__button");
        const panel = acc.querySelector(".accordion__panel");
        btn.addEventListener("click", () => {
            toggleClass(btn, "--open");
            toggleClass(panel, "--opened");
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + 15 + "px";
            }
        });
    });
};
